import React, {useEffect, useState} from 'react';
import {Controller, useFieldArray, useForm} from "react-hook-form";
import Counterpartiesfilds from "./counterpartiesfilds";
import {Row,Col} from "react-bootstrap";
import ContactsFields from "./contactsFields";
import LoadingButton from "../../base/components/loadingButton";
import CreateEditDocuments from "../../documents/components/createEditDocuments";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import Form from "react-bootstrap/Form";
import {Portlet, PortletHeader} from "../../../components/Portlet";
import MileCardsForm from "./mileCardsForm";
import CustomDatePicker from "../../base/components/forms/customDatePicker";



const ContactsForm = ({onSubmit, data}) => {
  const formController = useForm()
  const {handleSubmit,
  register,
  formState:{errors}} = formController
  console.log('errr', errors, data)

  const submit = (data,next) =>{
    let arrayWithString = []
    data.counterparties.forEach((c,i)=>arrayWithString.push(c.id))
    data.documents.forEach(doc=>{
      doc.photos = doc.photos.map(photo=>photo.url)
    })
    onSubmit({...data, counterparties:arrayWithString, nextInvalid: next})
  }
  const beforeSubmit = (data) =>{
    submit(data, false)
  }
  const saveAndNext = (data) =>{
    submit(data,true)
  }


  return (
    <>
      <form onSubmit={handleSubmit(beforeSubmit)}>
        <Row>
          <Col xs={6}>
            <Portlet>
              <PortletHeader title={'Клиент'}/>
            </Portlet>

            <Row>
              <Col>
                <FormHookInput
                  register={register(`lastName`, {required: true,})}
                  label={'Фамилия'}
                  defaultValue={data.lastName}
                  errors={errors}
                />
              </Col>
              <Col>
                <FormHookInput
                  register={register(`firstName`, {required: true,})}
                  label={'Имя'}
                  defaultValue={data.firstName}
                  errors={errors}
                />
              </Col>
              <Col>
                <CustomDatePicker formController={formController}
                                  label={"Дата рождения"}
                                  value={data.dateOfBirth}
                                  name={`dateOfBirth`}
                                  rules={{required: true}}/>
              </Col>
            </Row>
            <Form.Control
              as="textarea"
              className={'mt-2 mb-2'}
              defaultValue={data.notes}
              placeholder={'Основная информация'}
              rows={8}
              {...register(`notes`)}
            />
            <MileCardsForm formController={formController} data={data.mileCards}/>
            <Counterpartiesfilds
              formController={formController}
              data={data}/>
            {/*<ContactsFields formController={formController}*/}
            {/*                data={data}/>*/}
            <div className={'d-flex gap-2'}>
              <LoadingButton loading={false} title={'Сохранить'}/>
              <LoadingButton loading={false} title={'Сохранить и дальше'} onClick={handleSubmit(saveAndNext)}/>
            </div>
          </Col>
          <Col xs={6}>
            <CreateEditDocuments formController={formController}
                                 clientId={data?.id}
                                 dataDocs={data.documents}/>
          </Col>

        </Row>
      </form>

    </>
  );
};

export default ContactsForm;
